import React from 'react'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import CompanySelect from '../../../components/v2/CompanySelect'
import { useAppDispatch, useAppSelector } from '../../../store'
import Loader from '../../../components/Loader'
import { HealthState, setChooseMethod, setCompanyId } from '../../../store/healthSlice'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const HealthChooseMethod = () => {
  //
  const { t } = useTranslation()
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const HealthCompanies = filter.companyOffers
  //
  const SelectedCompanyArr: HealthState['filter']['selectedCompanies'] = filter.selectedCompanies
  //

  const matchingObjects = HealthCompanies?.filter((obj) => SelectedCompanyArr?.includes(obj.companyId as never))
  //

  //fake data
  const healthChoise = {
    id: 29,
    createdAt: '2023-10-04T14:05:41.514+04:00',
    updatedAt: '2023-10-08T15:25:43.855+04:00',
    translations: {
      ge: {
        title: 'Frani’s Choice or My Choice',
        stepName: 'რომელი მეთოდი',
      },
      en: {
        title: 'Frani’s Choice or My Choice',
        stepName: 'Which Method',
      },
    },
    listItems: [
      {
        id: 77,
        listId: 29,
        sort: 2,
        type: 'my-choice',
        image: `https://d3cd9cyzr3ifxh.cloudfront.net/images/1t.uqkcd9m8ro-Mask-Group-461.png`,
        translations: {
          ge: {
            title: 'შეთავაზებების მართვა',
            body: 'შეგიძლია მონიშნო მაქსიმუმ სამი სადაზღვევო კომპანია და შეადარო პირობები',
          },
          en: {
            title: 'Manage Offer',
            body: 'Select maximum three companies to compare terms',
          },
        },
        createdAt: '2023-10-04T14:05:41.532+04:00',
        updatedAt: '2023-10-26T14:33:34.023+04:00',
        title: 'My choice',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
      },
      {
        id: 76,
        listId: 29,
        sort: 1,
        type: 'frani-choice',
        image: `https://d3cd9cyzr3ifxh.cloudfront.net/images/h.7m0dam8onc-Frani's-choise.png`,
        translations: {
          ge: {
            title: 'ავტომატური შეთავაზება',
            body: 'ფრანი ალგორითმის მეშვეობით შეგირჩევს შენზე მორგებულ საუკეთესო პირობას',
          },
          en: {
            title: 'Automated Offer',
            body: 'Through an algorithm Frani will generate the best offer',
          },
        },
        createdAt: '2023-10-04T14:05:41.532+04:00',
        updatedAt: '2023-10-26T14:33:54.432+04:00',
        title: 'Frani choice',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
      },
    ],
  }
  //
  //
  const listItems = healthChoise?.listItems.slice().sort((a, b) => a.sort - b.sort)
  //
  //
  const stepName = healthChoise.translations[lang].stepName
  //
  const isHealthChoiseLoading = false
  //
  const mainLoading = isHealthChoiseLoading

  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('insuranceMethod')} />

        <HealthProgressbar stepName={stepName} />

        <Block>
          {listItems?.map((item, index) => {
            return (
              <HorizontalCard
                className="horizontal-card"
                key={index}
                disabled={false}
                title={item?.translations[lang].title}
                description={item?.translations[lang].body}
                imgUrl={item?.image}
                selected={item.type === filter.chooseMethod ? true : false}
                onClick={() => [dispatch(setChooseMethod(item.type))]}
              >
                {/*change filter choosemethod*/}
                {item.type === filter.chooseMethod && filter.chooseMethod === 'my-choice' ? (
                  <Inner>
                    <hr />
                    <CompanyTitle>{t('chooseInsuranceCompany')}</CompanyTitle>
                    <CompanyDescription>{t('chooseInsuranceCompanyRules')}</CompanyDescription>

                    <CompanySelect
                      closeMenuOnSelect={false}
                      onChange={(data) => dispatch(setCompanyId(data.map((item: any) => item.value)))}
                      isMulti={true}
                      maxSelectText={`${t('companyCmpare')}`}
                      placeholder={t('selectCompanies')}
                      showOptionCheckbox={true}
                      value={matchingObjects?.map((s) => ({
                        label: s.brandName?.[lang]?.title,
                        value: s.companyId,
                        imgUrl: s.companyLogo,
                      }))}
                      options={
                        HealthCompanies?.map((item) => ({
                          value: item.companyId,
                          label: item.brandName?.[lang]?.title,
                          imgUrl: item.companyLogo,
                        })) || []
                      }
                    />
                  </Inner>
                ) : null}
              </HorizontalCard>
            )
          })}
        </Block>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/health-start-date')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.chooseMethod && (filter.chooseMethod === 'frani-choice' || filter.chooseMethod === 'my-choice')
                ? false
                : true
            }
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                navigate('/health-offer')
              }
              //
              if (filter.chooseMethod === 'my-choice') {
                navigate('/health-offers')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 80px;
  min-height: 100vh;
`

const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`

const Block = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-inline: auto;
  width: fit-content;

  gap: 24px;
  ${Responsive.mobile} {
    margin-top: 24px;
    gap: 20px;
  }
`

const Inner = styled.div``

const CompanyTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 1px;
`
const CompanyDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  width: min-content;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

//
export default HealthChooseMethod
